// extracted by mini-css-extract-plugin
export default {"container":"R1-z"};